<template>
	<DesktopNavTemplate :styles="styles" :show-add-funds="showAddFunds">
		<template #left>
			<ul class="main-nav__menu ml-150">
				<li v-for="(link, accountLinkId) in nav.links" :key="accountLinkId" class="main-nav__menu-item">
					<NavigationLinkDesktop
						:link="link"
						:is-sticky="isSticky"
						:is-transparent-dark-text="isTransparentDarkText"
					/>
				</li>
			</ul>
		</template>
		<template #right>
			<div class="display-flex align-items-center">
				<ul class="main-nav__menu">
					<NotificationDropdown
						:expanded="notificationDropdownExpanded"
						@expand-notification-dropdown="expandNotificationDropdown"
					/>
					<UserDropdown
						:expanded="userDropdownExpanded"
						:has-multiple-entities="hasMultipleEntities"
						@expand-user-dropdown="expandUserDropdown"
					/>
				</ul>
			</div>
		</template>
	</DesktopNavTemplate>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';
import AdvisorAuthenticatedNav from '@classes/AdvisorAuthenticatedNav';
import AuthenticatedNav from '@classes/AuthenticatedNav';
import DesktopNavTemplate from '@components/header/navigation/desktop/desktop-nav-template.vue';
import { HeaderStyle } from 'types/header';
import { InvestmentEntity } from 'types/investment-entity';
import NavigationLinkDesktop from './navigation-link-desktop.vue';
import NotificationDropdown from '@components/header/navigation/notification-dropdown.vue';
import { useAppStore } from '@stores/app';
import { useInvestmentEntityStore } from '@stores/investment-entity';
import UserDropdown from '@components/header/navigation/user-dropdown.vue';
import { useUserStore } from '@stores/user';

interface Props {
	isTransparent?: boolean;
	isSticky?: boolean;
	isTransparentDarkText?: boolean;
	styles: HeaderStyle;
}

withDefaults(defineProps<Props>(), {
	isTransparent: false,
	isSticky: false,
	isTransparentDarkText: false
});

const appStore = useAppStore();
const investmentEntityStore = useInvestmentEntityStore();
const userStore = useUserStore();

const userDropdownExpanded = ref(false);
const notificationDropdownExpanded = ref(false);

const investmentEntityObject = computed((): InvestmentEntity => {
	return investmentEntityStore.investmentEntityObject;
});

const hasMultipleEntities = computed((): boolean => {
	return nav.value.multipleInvestmentEntities;
});

const nav = computed((): AuthenticatedNav | AdvisorAuthenticatedNav => {
	return appStore.isAdvisor
		? new AdvisorAuthenticatedNav(userStore.user)
		: new AuthenticatedNav(userStore.user, investmentEntityObject.value);
});

const showAddFunds = computed((): boolean => {
	return !appStore.isAdvisor && !investmentEntityStore.hasNeverBeenAnInvestor;
});

function expandNotificationDropdown(expanded: boolean) {
	notificationDropdownExpanded.value = expanded;
	if (expanded && userDropdownExpanded.value) {
		userDropdownExpanded.value = false;
	}
}

function expandUserDropdown(expanded: boolean) {
	userDropdownExpanded.value = expanded;
	if (expanded && notificationDropdownExpanded.value) {
		notificationDropdownExpanded.value = false;
	}
}
</script>
